import Swiper from "swiper"
import { Navigation } from "swiper/modules"

const swiper = new Swiper(".partners", {
  modules: [Navigation],
  a11y: true,
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 48,
  mousewheel: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
})
